// extracted by mini-css-extract-plugin
export var inverted = "EXgSjwWYE0Pg_AZ8aKc2";
export var large = "SOkDVOxDxSZlUcnjf4Im";
export var root = "MIoC4D9wCFOGprLXXaeP";
export var spin = "P7Z3yZjoO5idCMNSX6A4";